export default "__VITE_ASSET__DQYqR$R7__"